import React from "react";
import { Input, Space, Col, Row } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { EXPLORE_MODES } from "./constants";
import { Line } from "@ant-design/charts";
import { InvestingCountryBarChart } from "./charts/InvestingCountryBarChart";
import { InvestingCountryTreeMap } from "./charts/InvestingCountryTreeMap";
import { SectorsPieChart } from "./charts/SectorsPieChart";
import { TypeOfInvestmentPieChart } from "./charts/TypeOfInvestmentPieChart";
import { LandOwnerWordCloud } from "./charts/LandOwnerWordCloud";
import { NameOfInvestorWordCloud } from "./charts/NameOfInvestorWordCloud";
import { TotalAmtOfCapBarChart } from "./charts/TotalAmtOfCapBarChart";

const data = [
  { year: "1991", value: 3 },
  { year: "1992", value: 4 },
  { year: "1993", value: 3.5 },
  { year: "1994", value: 5 },
  { year: "1995", value: 4.9 },
  { year: "1996", value: 6 },
  { year: "1997", value: 7 },
  { year: "1998", value: 9 },
  { year: "1999", value: 13 },
];

const config = {
  data,
  xField: "year",
  yField: "value",
  point: {
    size: 5,
    shape: "diamond",
  },
  label: {
    style: {
      fill: "#aaa",
    },
  },
};
export const Visual = () => {
  return (
    <div>
      <h3>{EXPLORE_MODES.VISUAL.label}</h3>
      {/* <Input size="large" placeholder="Search" prefix={<SearchOutlined />} /> */}
      <Row>
        <Space size={100} direction="vertical" className="container">
          <Col span="24">
            <div>
              <h4>Investing Countries Bar Chart</h4>
              <InvestingCountryBarChart />
            </div>
          </Col>
          <Col span="24">
            <div>
              <h4>Investing Countries Tree Map</h4>
              <InvestingCountryTreeMap />
            </div>
          </Col>
          <Col span="24">
            <div>
              <h4>Sectors Pie Chart</h4>
              <SectorsPieChart />
            </div>
          </Col>
          <Col span="24">
            <div>
              <h4>Name of Investor Word Cloud</h4>
              <NameOfInvestorWordCloud />
            </div>
          </Col>
          <Col span="24">
            <div>
              <h4>Type Of Investment Pie Chart</h4>
              <TypeOfInvestmentPieChart />
            </div>
          </Col>
          <Col span="24">
            <div>
              <h4>Land Owner Word Cloud</h4>
              <LandOwnerWordCloud />
            </div>
          </Col>
          <Col span="24">
            <div>
              <h4>Total Amount Of Capital Bar Chart (In Millions of USD)</h4>
              <TotalAmtOfCapBarChart />
            </div>
          </Col>
        </Space>
      </Row>
    </div>
  );
};
